<template>
    <FormWrapper
        v-if="!loading"
        ref="customFormRef"
        :images-model="images"
        :form-model="form"
        :mandatory-fields="mandatoryFields"
        :changes-model="changes"
        :layer-name="layerName"
        :object-id="objectId"
        :project-id="projectId"
        :latitude="latitude"
        :longitude="longitude"
        @update:images-model="
            (e) => {
                images = e;
            }
        "
        @update:value-missing="
            (e) => {
                valueMissing = e;
            }
        "
        @update:form-model="
            (e) => {
                form = e;
            }
        "
        @update:changes-model="
            (e) => {
                changes = e;
            }
        "
    >
        <template #menu_tabs>
            <el-row class="scroll-menu">
                <el-col :span="8">
                    <div
                        @click="selectTab('METIER')"
                        class="tabs"
                        :class="{ selectedTab: selectedTab === 'METIER' }"
                    >
                        METIER
                    </div>
                </el-col>

                <el-col :span="8">
                    <div
                        @click="selectTab('GENERAL')"
                        class="tabs"
                        :class="{ selectedTab: selectedTab === 'GENERAL' }"
                    >
                        GENERAL
                    </div>
                </el-col>

                <el-col :span="8">
                    <div
                        @click="selectTab('CAB/ECL')"
                        class="tabs"
                        :class="{ selectedTab: selectedTab === 'CAB/ECL' }"
                    >
                        CAB/ECL
                    </div>
                </el-col>

                <el-col :span="8">
                    <div
                        @click="selectTab('TIROIR')"
                        class="tabs"
                        :class="{ selectedTab: selectedTab === 'TIROIR' }"
                    >
                        TIROIR
                    </div>
                </el-col>
            </el-row>
        </template>
        <template #main_form>
            <el-row>
                <el-col
                    :span="24"
                    v-show="selectedTab === 'METIER'"
                >
                    <CustomInput
                        :label="labels.st_code"
                        :value="form.st_code"
                        :maxlength="254"
                        :disabled="true"
                    />
                    <CustomInputSelect
                        :label="labels.statut + ' *'"
                        :class="{ 'text-warning': valueMissing }"
                        :options="options.statut"
                        :value="form.statut"
                        @update:value="
                            (newValue) => saveData('statut', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.st_nd_code"
                        :value="form.st_nd_code"
                        :maxlength="254"
                        :disabled="true"
                    />
                    <CustomInput
                        :label="labels.st_codeext"
                        :value="form.st_codeext"
                        :disabled="true"
                    />
                    <CustomInputSwitch
                        :label="labels.donnees_metier"
                        :options="options.donnees_metier"
                        :value="form.donnees_metier"
                        @update:value="
                            (newValue) => saveData('donnees_metier', newValue)
                        "
                    />
                    <CustomInput
                        v-show="condition_st_nom()"
                        :label="labels.st_nom"
                        :value="form.st_nom"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_prop()"
                        :label="labels.st_prop"
                        :value="form.st_prop"
                        :maxlength="20"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_gest()"
                        :label="labels.st_gest"
                        :value="form.st_gest"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_user()"
                        :label="labels.st_user"
                        :value="form.st_user"
                        :maxlength="20"
                        :disabled="true"
                    />
                    <CustomInputSelect
                        v-show="condition_st_proptyp()"
                        :label="labels.st_proptyp"
                        :options="options.st_proptyp"
                        :value="form.st_proptyp"
                        :disabled="true"
                    />
                    <CustomInputSelect
                        v-show="condition_st_statut()"
                        :label="labels.st_statut"
                        :options="options.st_statut"
                        :value="form.st_statut"
                        :disabled="true"
                    />
                    <CustomInputSelect
                        v-show="condition_st_etat()"
                        :label="labels.st_etat"
                        :options="options.st_etat"
                        :value="form.st_etat"
                        :disabled="true"
                    />
                    <CustomDatePicker
                        v-show="condition_st_dateins()"
                        :label="labels.st_dateins"
                        :value="form.st_dateins"
                        :disabled="true"
                    />
                    <CustomDatePicker
                        v-show="condition_st_datemes()"
                        :label="labels.st_datemes"
                        :value="form.st_datemes"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_avct()"
                        :label="labels.st_avct"
                        :value="form.st_avct"
                        :maxlength="1"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_typephy()"
                        :label="labels.st_typephy"
                        :value="form.st_typephy"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_typelog()"
                        :label="labels.st_typelog"
                        :value="form.st_typelog"
                        :maxlength="10"
                        :disabled="true"
                    />
                    <InputNumber
                        v-show="condition_st_nblines()"
                        :label="labels.st_nblines"
                        :value="form.st_nblines"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_ad_code()"
                        :label="labels.st_ad_code"
                        :value="form.st_ad_code"
                        :maxlength="254"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_comment()"
                        :label="labels.st_comment"
                        :value="form.st_comment"
                        :disabled="true"
                    />
                    <CustomDatePicker
                        v-show="condition_st_creadat()"
                        :label="labels.st_creadat"
                        :value="form.st_creadat"
                        :disabled="true"
                    />
                    <CustomDatePicker
                        v-show="condition_st_majdate()"
                        :label="labels.st_majdate"
                        :value="form.st_majdate"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_majsrc()"
                        :label="labels.st_majsrc"
                        :value="form.st_majsrc"
                        :maxlength="254"
                        :disabled="true"
                    />
                    <CustomDatePicker
                        v-show="condition_st_abddate()"
                        :label="labels.st_abddate"
                        :value="form.st_abddate"
                        :disabled="true"
                    />
                    <CustomInput
                        v-show="condition_st_abdsrc()"
                        :label="labels.st_abdsrc"
                        :value="form.st_abdsrc"
                        :maxlength="254"
                        :disabled="true"
                    />
                </el-col>
                <el-col
                    :span="24"
                    v-show="selectedTab === 'GENERAL'"
                >
                    <CustomRadioButton
                        :label="labels.georeferencement_nro"
                        :options="options.georeferencement_nro"
                        :value="form.georeferencement_nro"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('georeferencement_nro', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_georeferencement_nro + ' *'"
                        :images="images.img_georeferencement_nro"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_georeferencement_nro', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_georeferencement_nro"
                        :value="form.commentaire_georeferencement_nro"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_georeferencement_nro',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.proprete"
                        :options="options.proprete"
                        :value="form.proprete"
                        size="small"
                        @update:value="
                            (newValue) => saveData('proprete', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_proprete + ' *'"
                        :images="images.img_proprete"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) => saveImage('img_proprete', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_proprete"
                        :value="form.commentaire_proprete"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData('commentaire_proprete', newValue)
                        "
                    />
                    <CustomRadioButton
                        :label="labels.nb_u_correct"
                        :options="options.nb_u_correct"
                        :value="form.nb_u_correct"
                        size="small"
                        @update:value="
                            (newValue) => saveData('nb_u_correct', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_nb_u_correct"
                        :images="images.img_nb_u_correct"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_nb_u_correct', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_nb_u_correct"
                        :value="form.commentaire_nb_u_correct"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData('commentaire_nb_u_correct', newValue)
                        "
                    />
                    <CustomRadioButton
                        :label="labels.contrôle_acces"
                        :options="options.contrôle_acces"
                        :value="form.contrôle_acces"
                        size="small"
                        @update:value="
                            (newValue) => saveData('contrôle_acces', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_contrôle_acces + ' *'"
                        :images="images.img_contrôle_acces"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_contrôle_acces', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_contrôle_acces"
                        :value="form.commentaire_contrôle_acces"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData('commentaire_contrôle_acces', newValue)
                        "
                    />
                </el-col>
                <el-col
                    :span="24"
                    v-show="selectedTab === 'CAB/ECL'"
                >
                    <CustomRadioButton
                        :label="labels.etiquettes_cab_ecl"
                        :options="options.etiquettes_cab_ecl"
                        :value="form.etiquettes_cab_ecl"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('etiquettes_cab_ecl', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_etiquettes_cab_ecl + ' *'"
                        :images="images.img_etiquettes_cab_ecl"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_etiquettes_cab_ecl', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_etiquettes_cab_ecl"
                        :value="form.commentaire_etiquettes_cab_ecl"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_etiquettes_cab_ecl',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.parcours_cables_transport"
                        :options="options.parcours_cables_transport"
                        :value="form.parcours_cables_transport"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('parcours_cables_transport', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_parcours_cables_transport + ' *'"
                        :images="images.img_parcours_cables_transport"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage(
                                    'img_parcours_cables_transport',
                                    newValue,
                                )
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_nb_fibres_transport"
                        :value="form.commentaire_nb_fibres_transport"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_nb_fibres_transport',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.fixation_eclateur"
                        :options="options.fixation_eclateur"
                        :value="form.fixation_eclateur"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('fixation_eclateur', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_fixation_eclateur + ' *'"
                        :images="images.img_fixation_eclateur"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_fixation_eclateur', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_fixation_eclateur"
                        :value="form.commentaire_fixation_eclateur"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_fixation_eclateur',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.presence_gaine_annelee"
                        :options="options.presence_gaine_annelee"
                        :value="form.presence_gaine_annelee"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('presence_gaine_annelee', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_presence_gaine_annelee + ' *'"
                        :images="images.img_presence_gaine_annelee"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage(
                                    'img_presence_gaine_annelee',
                                    newValue,
                                )
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_presence_gaine_annelee"
                        :value="form.commentaire_presence_gaine_annelee"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_presence_gaine_annelee',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.epanouissement"
                        :options="options.epanouissement"
                        :value="form.epanouissement"
                        size="small"
                        @update:value="
                            (newValue) => saveData('epanouissement', newValue)
                        "
                    />

                    <div v-show="condition_img_epanouissement()">
                        <InputCamera
                            :label="labels.img_epanouissement + ' *'"
                            :images="images.img_epanouissement"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage('img_epanouissement', newValue)
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="condition_commentaire_epanouissement()"
                        :label="labels.commentaire_epanouissement"
                        :value="form.commentaire_epanouissement"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData('commentaire_epanouissement', newValue)
                        "
                    />
                    <CustomRadioButton
                        :label="labels.fixation_cables_entree"
                        :options="options.fixation_cables_entree"
                        :value="form.fixation_cables_entree"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('fixation_cables_entree', newValue)
                        "
                    />

                    <div v-show="condition_img_fixation_cables_entree()">
                        <InputCamera
                            :label="labels.img_fixation_cables_entree + ' *'"
                            :images="images.img_fixation_cables_entree"
                            :layer-name="layerName"
                            @update:images="
                                (newValue) =>
                                    saveImage(
                                        'img_fixation_cables_entree',
                                        newValue,
                                    )
                            "
                        />
                    </div>
                    <CustomInput
                        v-show="condition_commentaire_fixation_cables_entree()"
                        :label="labels.commentaire_fixation_cables_entree"
                        :value="form.commentaire_fixation_cables_entree"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_fixation_cables_entree',
                                    newValue,
                                )
                        "
                    />
                </el-col>
                <el-col
                    :span="24"
                    v-show="selectedTab === 'TIROIR'"
                >
                    <CustomRadioButton
                        :label="labels.etiquettes_tiroir"
                        :options="options.etiquettes_tiroir"
                        :value="form.etiquettes_tiroir"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('etiquettes_tiroir', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_etiquettes_tiroir + ' *'"
                        :images="images.img_etiquettes_tiroir"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_etiquettes_tiroir', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_etiquettes_tiroir"
                        :value="form.commentaire_etiquettes_tiroir"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_etiquettes_tiroir',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.fixation_tiroir"
                        :options="options.fixation_tiroir"
                        :value="form.fixation_tiroir"
                        size="small"
                        @update:value="
                            (newValue) => saveData('fixation_tiroir', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_fixation_tiroir + ' *'"
                        :images="images.img_fixation_tiroir"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_fixation_tiroir', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_fixation_tiroir"
                        :value="form.commentaire_fixation_tiroir"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_fixation_tiroir',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.verification_position_tiroirs"
                        :options="options.verification_position_tiroirs"
                        :value="form.verification_position_tiroirs"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'verification_position_tiroirs',
                                    newValue,
                                )
                        "
                    />
                    <InputCamera
                        :label="labels.img_verification_position_tiroirs + ' *'"
                        :images="images.img_verification_position_tiroirs"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage(
                                    'img_verification_position_tiroirs',
                                    newValue,
                                )
                        "
                    />
                    <CustomInput
                        :label="
                            labels.commentaire_verification_position_tiroirs
                        "
                        :value="form.commentaire_verification_position_tiroirs"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_verification_position_tiroirs',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.detubage_fibres_lovage_fibres"
                        :options="options.detubage_fibres_lovage_fibres"
                        :value="form.detubage_fibres_lovage_fibres"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'detubage_fibres_lovage_fibres',
                                    newValue,
                                )
                        "
                    />
                    <InputCamera
                        :label="labels.img_detubage_fibres_lovage_fibres + ' *'"
                        :images="images.img_detubage_fibres_lovage_fibres"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage(
                                    'img_detubage_fibres_lovage_fibres',
                                    newValue,
                                )
                        "
                    />
                    <CustomInput
                        :label="
                            labels.commentaire_detubage_fibres_lovage_fibres
                        "
                        :value="form.commentaire_detubage_fibres_lovage_fibres"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_detubage_fibres_lovage_fibres',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.presence_bouchons"
                        :options="options.presence_bouchons"
                        :value="form.presence_bouchons"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('presence_bouchons', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_presence_bouchons + ' *'"
                        :images="images.img_presence_bouchons"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_presence_bouchons', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_presence_bouchons"
                        :value="form.commentaire_presence_bouchons"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_presence_bouchons',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.arrimage_gaine"
                        :options="options.arrimage_gaine"
                        :value="form.arrimage_gaine"
                        size="small"
                        @update:value="
                            (newValue) => saveData('arrimage_gaine', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_arrimage_gaine + ' *'"
                        :images="images.img_arrimage_gaine"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_arrimage_gaine', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_arrimage_gaine"
                        :value="form.commentaire_arrimage_gaine"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData('commentaire_arrimage_gaine', newValue)
                        "
                    />
                    <CustomRadioButton
                        :label="labels.ouverture_libre_tiroirs"
                        :options="options.ouverture_libre_tiroirs"
                        :value="form.ouverture_libre_tiroirs"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('ouverture_libre_tiroirs', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_ouverture_libre_tiroirs + ' *'"
                        :images="images.img_ouverture_libre_tiroirs"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage(
                                    'img_ouverture_libre_tiroirs',
                                    newValue,
                                )
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_ouverture_libre_tiroirs"
                        :value="form.commentaire_ouverture_libre_tiroirs"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_ouverture_libre_tiroirs',
                                    newValue,
                                )
                        "
                    />
                    <CustomRadioButton
                        :label="labels.cheminement_bloolite"
                        :options="options.cheminement_bloolite"
                        :value="form.cheminement_bloolite"
                        size="small"
                        @update:value="
                            (newValue) =>
                                saveData('cheminement_bloolite', newValue)
                        "
                    />
                    <InputCamera
                        :label="labels.img_cheminement_bloolite + ' *'"
                        :images="images.img_cheminement_bloolite"
                        :layer-name="layerName"
                        @update:images="
                            (newValue) =>
                                saveImage('img_cheminement_bloolite', newValue)
                        "
                    />
                    <CustomInput
                        :label="labels.commentaire_cheminement_bloolite"
                        :value="form.commentaire_cheminement_bloolite"
                        :maxlength="254"
                        @update:value="
                            (newValue) =>
                                saveData(
                                    'commentaire_cheminement_bloolite',
                                    newValue,
                                )
                        "
                    />
                </el-col>
            </el-row>
        </template>
    </FormWrapper>
</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue';

import type { FormDataInterface } from '@connect-field/client/components/forms/form.types';
import FormTemplate from '@connect-field/client/components/forms/FormTemplate.vue';

import {
    labels,
    options,
} from '@connect-field/client/components/forms/StrategicScout/audit_form_nro.data';

interface DataInterface extends FormDataInterface {}

export default defineComponent({
    extends: FormTemplate,
    data(): DataInterface {
        return {
            changes: false,
            form: {},
            images: {
                img_georeferencement_nro: [],
                img_proprete: [],
                img_nb_u_correct: [],
                img_contrôle_acces: [],
                img_etiquettes_cab_ecl: [],
                img_parcours_cables_transport: [],
                img_fixation_eclateur: [],
                img_presence_gaine_annelee: [],
                img_epanouissement: [],
                img_fixation_cables_entree: [],
                img_etiquettes_tiroir: [],
                img_fixation_tiroir: [],
                img_verification_position_tiroirs: [],
                img_detubage_fibres_lovage_fibres: [],
                img_presence_bouchons: [],
                img_arrimage_gaine: [],
                img_ouverture_libre_tiroirs: [],
                img_cheminement_bloolite: [],
            },
            labels,
            loading: true,
            mandatoryFields: [
                'statut',
                'img_georeferencement_nro',
                'img_proprete',
                'img_contrôle_acces',
                'img_etiquettes_cab_ecl',
                'img_parcours_cables_transport',
                'img_fixation_eclateur',
                'img_presence_gaine_annelee',
                'img_epanouissement',
                'img_fixation_cables_entree',
                'img_etiquettes_tiroir',
                'img_fixation_tiroir',
                'img_verification_position_tiroirs',
                'img_detubage_fibres_lovage_fibres',
                'img_presence_bouchons',
                'img_arrimage_gaine',
                'img_ouverture_libre_tiroirs',
                'img_cheminement_bloolite',
            ],
            options,
            selectedTab: 'METIER',
            valueMissing: false,
        };
    },
    methods: {
        condition_st_nom(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_prop(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_gest(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_user(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_proptyp(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_statut(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_etat(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_dateins(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_datemes(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_avct(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_typephy(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_typelog(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_nblines(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_ad_code(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_comment(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_creadat(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_majdate(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_majsrc(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_abddate(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_st_abdsrc(): boolean {
            const { donnees_metier } = this.form;
            return donnees_metier === true;
        },
        condition_img_epanouissement(): boolean {
            const { epanouissement } = this.form;
            return epanouissement?.startsWith('Non-conforme');
        },
        condition_commentaire_epanouissement(): boolean {
            const { epanouissement } = this.form;
            return epanouissement?.startsWith('Non-conforme');
        },
        condition_img_fixation_cables_entree(): boolean {
            const { fixation_cables_entree } = this.form;
            return fixation_cables_entree?.startsWith('Non-conforme');
        },
        condition_commentaire_fixation_cables_entree(): boolean {
            const { fixation_cables_entree } = this.form;
            return fixation_cables_entree?.startsWith('Non-conforme');
        },
    },
});
</script>
